import { Badge, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { FC } from 'react';

import mobileClasses from '../../styles/farmer-mobile.module.css';
import {
  AnswerWithDistance,
  formatDistanceMeters,
} from '../../utils/harvest-proof-fields';

import {
  HarvestProofAnswerPublic,
  isHarvestProofAnswerSubmitted,
} from '@harvest-proof/data-access';


interface FieldsListProps {
  items: AnswerWithDistance[];
  onSelect: (answer: HarvestProofAnswerPublic) => void;
}

export const FieldsList: FC<FieldsListProps> = ({ items, onSelect }) => (
  <Stack gap={0}>
    <Text className={mobileClasses.listHeader} fw={600} size="sm">
      Parcelles ({items.filter((i) => !isHarvestProofAnswerSubmitted(i.answer)).length}{' '}
      restantes)
    </Text>
    {items.map(({ answer, distanceMeters, isInside }) => {
      const isFinished = isHarvestProofAnswerSubmitted(answer);

      return (
        <UnstyledButton
          className={mobileClasses.listRow}
          component={isFinished ? 'div' : 'button'}
          data-disabled={isFinished || undefined}
          disabled={isFinished}
          key={answer.id}
          onClick={
            isFinished
              ? undefined
              : () => {
                  onSelect(answer);
                }
          }
        >
          <Group justify="space-between" wrap="nowrap">
            <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
              <Text fw={600} lineClamp={1} size="md">
                {answer.field.properties?.name ?? `Parcelle ${answer.id}`}
              </Text>
              <Text c="dimmed" size="sm">
                {answer.field.properties?.area?.toFixed?.(2) ?? '-'} ha
              </Text>
            </Stack>
            <Group gap="sm" wrap="nowrap">
              {isFinished ? (
                <Badge color="green" size="lg" variant="light">
                  Envoyé
                </Badge>
              ) : isInside ? (
                <Badge color="teal" size="lg" variant="light">
                  Sur parcelle
                </Badge>
              ) : (
                <Text c="dimmed" size="md" style={{ whiteSpace: 'nowrap' }}>
                  {formatDistanceMeters(distanceMeters)}
                </Text>
              )}
              {!isFinished ? <IconChevronRight size={22} /> : null}
            </Group>
          </Group>
        </UnstyledButton>
      );
    })}
  </Stack>
);
